import { Popup } from "@emisgroup/ui-popup";
import React from "react";
import { Button } from "../../components/Common/UI/Index";

export type SingleLine = string;
export type MultipleLine = { text: string }[];

interface ITooltipProps {
  title?: string;
  text: SingleLine | MultipleLine;
  Trigger: React.FC;
}

export const Tooltip: React.FC<ITooltipProps> = ({ text, title, Trigger }) => {
  const textTemplate =
    Array.isArray(text) ? text.map((item, index) => <div key={index}>{item.text}</div>) : <div>{text }</div>;

  return  (
    <Popup>
      <Popup.Trigger>
        <Button borderless={true} style={{ display: "flex", alignItems: "center", all:"unset" }}>
          <Trigger/>
        </Button>
      </Popup.Trigger>
      <Popup.Content>
        <div style={{ padding: "0.5rem 1rem" }}>
          <div><b>{title}</b></div>
          {textTemplate}
        </div>
      </Popup.Content>
    </Popup>
  );
};
